// extracted by mini-css-extract-plugin
export default {"wrapper":"alert_wrapper--E3RVh","mainContent":"alert_mainContent--K4k4c","close":"alert_close--AsDAk","additionalContent":"alert_additionalContent--tp5J9"};